module.exports = __webpack_public_path__ + "img/运动记录icon.c71d81a3.png";